import gql from 'graphql-tag'

export const GET_GBL_LOCATION_BY_SLUG = gql`
  query getGblLocationBySlug($slug: String!) {
    getGblLocationBySlug(slug: $slug) {
      id
      name
      slug
      address
      city
      state
      stateName
      zip
      phone
      fullAddress
      mapUrl
      isActive
      hours {
        weekday
        saturday
        sunday
      }
      services
      storeID
    }
  }
`

export const GET_GBL_LOCATIONS = gql`
  query getGblLocations {
    getGblLocations {
      name
      slug
      city
      state
      stateName
      storeID
      isActive
    }
  }
`
